/** Resumo do dia — cliente. Agregado no servidor a cada leitura. */
import { useQuery } from '@tanstack/react-query';

export interface ResumoDoDia {
  dayId: string;
  date: string;
  title: string | null;
  ready: boolean;
  summaryTime: string;
  activities: { done: number; total: number; items: { id: string; title: string; place: string | null; coverThumbUrl?: string | null }[] };
  photos: { count: number; thumbUrls: string[] };
  groupSpentMinor: number;
  currency: string;
  stamps: string[];
  meeting: { title: string; firstArrival: string | null; arrivals: number } | null;
  polls: { question: string; winner: string | null }[];
}

export function useResumoDoDia(tripId: string, dayId: string | null, ligado = true) {
  return useQuery({
    queryKey: ['resumo', tripId, dayId],
    queryFn: async () => {
      const res = await fetch(`/api/v1/trips/${tripId}/days/${dayId}/summary`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`Falha (${res.status})`);
      return (await res.json()) as ResumoDoDia;
    },
    enabled: ligado && !!dayId,
    staleTime: 60_000,
  });
}
